export function formatQuizData(createQuiz) {
    return {
        theme: createQuiz.theme || '',
        date: createQuiz.date || '',
        disabled: createQuiz.disabled,
        questions: (createQuiz.questions || []).flatMap((q, idx) => {
            const variants = q.variants || {};
            const questionsList = [];

            Object.entries(variants).forEach(([variantKey, variantData]) => {
                if (variantData.questionText && variantData.answers?.length > 0) {
                    const options = variantData.answers.map(a => ({
                        id: a.id || null,
                        option_text: a.text,
                        is_correct: !!a.correct,
                    }));
                    const correctCount = options.filter(o => o.is_correct).length;

                    questionsList.push({
                        id: q.id || null,
                        question_number: idx + 1,
                        question_text: variantData.questionText,
                        image: variantData.image ? variantData.image.id : null,
                        variant: variantKey,
                        correct_answer_type: correctCount > 1 ? 'multiple' : 'single',
                        options,
                    });
                }
            });

            return questionsList;
        }),
    };
}

export const formatReduxData = data => {
    const parseDate = dateValue => {
        if (!dateValue) return null;

        if (typeof dateValue === 'string' && dateValue.includes('.')) {
            const [day, month, year] = dateValue.split('.');
            const date = new Date(`${year}-${month}-${day}T00:00:00Z`);
            return date.toISOString();
        }
        return dateValue;
    };

    const groupedQuestions = {};

    (data.questions || []).forEach(q => {
        const questionNumber = q.question_number;

        if (!groupedQuestions[questionNumber]) {
            groupedQuestions[questionNumber] = {
                id: null,
                variants: {},
            };
        }

        groupedQuestions[questionNumber].variants[q.variant] = {
            id: q.id,
            questionText: q.question_text || '',

            image:
                (q.image &&
                    q.imageFile && {
                        id: q.image ? q.image : null,
                        fileUrl: q.imageFile ? q.imageFile.fileUrl : null,
                    }) ||
                null,
            answers: (q.options || []).map(option => ({
                id: option.id,
                text: option.option_text || '',
                correct: !!option.is_correct,
            })),
        };
    });

    const questions = Object.keys(groupedQuestions)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map(questionNumber => groupedQuestions[questionNumber]);

    return {
        id: data.id || null,
        theme: data.theme || null,
        disabled: data.disabled,
        date: parseDate(data.date),
        questions: questions,
    };
};
